import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 18h15.293c1.02 0 1.972 -.503 2.536 -1.34l2.171 -3.66h-18.479z","key":"svg-0"}],["path",{"d":"M14 8l-1 -2","key":"svg-1"}],["path",{"d":"M6.107 12.675l1.384 -4.675h8l2.675 4.598","key":"svg-2"}]]

const IconFerry = createReactComponent('outline', 'ferry', 'Ferry', __iconNode);

export default IconFerry;